import PropTypes from "prop-types"
import React, {Component, Suspense} from "react"
import {connect} from "react-redux"
import {Route, Routes} from "react-router-dom"
import {Grid} from "semantic-ui-react"
import Header from "../components/Header/header"
import {Page} from "../constants/page/pages"
import {PagesArchitecture} from "../constants/page/pagesArchitecture"
import {buildMainLayoutRoutes} from "../config/routeConfig"
import {saveCookiesChoices} from "../shared-components/actions/localStorage/cookies/cookiesActions"
import CheckBrowserContainer from "../shared-components/components/CheckBrowser/checkBrowserContainer"
import Footer from "../shared-components/components/Footer/footer"
import NotificationsContainer from "../shared-components/components/Notifications/notificationsContainer"
import {DOMISERVE_CONTACT_URL} from "../shared-components/constants/links"
import withRouter from "../shared-components/wrappers/withRouter"
import {
    getCookiesChoices,
    getModalStep,
    isCookiesModalOpened,
    isCookiesUserAcceptanceExpired,
    isUserAcceptedCookies,
} from "../store/selectors/localStorage/cookiesSelectors"
import {getUserFullname, getUserPermissions, isUserConnected} from "../store/selectors/localStorage/userSelectors"
import {getNotifications} from "../store/selectors/notifications/notificationsSelectors"
import {getActualPage} from "../store/selectors/temporaries/pageSelectors"
import {MatomoTrackPageView} from "./matomoTrackPageView"
import "./mainLayout.scss"
import CookiesNotificationContainer from "../components/CookiesNotification/cookiesNotificationContainer"

class MainLayout extends Component {
    render() {
        const {onContactClick, onCookiesClick, onLegalClick} = this.props
        const mainLayoutRoutes = buildMainLayoutRoutes()

        return (
            <div
                className={
                    "main-layout" +
                    (process.env.NODE_ENV === "production" && !process.env.REACT_APP_PROD_MODE
                        ? " main-layout-bordered"
                        : "")
                }
            >
                <MatomoTrackPageView />
                <div className="main-page">
                    <Header className="menu-container" />
                    <Grid centered className="notifications-container">
                        <Grid.Column only="computer" width={1} />
                        <Grid.Column width={14}>
                            <NotificationsContainer
                                displayNotifications={this.props.actualPage !== Page.LOGIN}
                                getNotifications={getNotifications}
                            />
                        </Grid.Column>
                        <Grid.Column only="computer" width={1} />
                    </Grid>
                    <CheckBrowserContainer userAgent={window.navigator.userAgent} />
                    <div className="main-content">
                        <Suspense fallback={<div />}>
                            <Routes>
                                {mainLayoutRoutes.map(routeProps => (
                                    <Route element={routeProps.element} key={routeProps.key} path={routeProps.path} />
                                ))}
                            </Routes>
                        </Suspense>
                    </div>
                </div>
                <CookiesNotificationContainer
                    getCookiesChoices={getCookiesChoices}
                    getModalStep={getModalStep}
                    isCookiesModalOpened={isCookiesModalOpened}
                    isCookiesUserAcceptanceExpired={isCookiesUserAcceptanceExpired}
                    isUserAcceptedCookies={isUserAcceptedCookies}
                />
                <Footer onContactClick={onContactClick} onCookiesClick={onCookiesClick} onLegalClick={onLegalClick} />
            </div>
        )
    }
}

MainLayout.propTypes = {
    actualPage: PropTypes.string.isRequired,
    onCookiesClick: PropTypes.func.isRequired,
    onContactClick: PropTypes.func.isRequired,
    onLegalClick: PropTypes.func.isRequired,
}

const mapStateToProps = state => {
    let actualPage = getActualPage(state)
    return {
        actualPage: actualPage,
        isUserConnected: isUserConnected(state) && actualPage !== Page.BYPASS_LOGIN,
        username: getUserFullname(state),
        userPermissions: getUserPermissions(state),
    }
}

const mapDispatchToProps = (dispatch, props) => ({
    onCookiesClick: () => dispatch(saveCookiesChoices({isModalOpened: true, step: "CONFIGURATION"})),
    onContactClick: () => window.open(DOMISERVE_CONTACT_URL),
    onLegalClick: () => props.router.navigate(PagesArchitecture[Page.LEGAL_NOTICE].route),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MainLayout))
